import { gql } from '@apollo/client';

export const S3DeleteDocumentMutation = gql`
  mutation s3DeleteDocument($bucketName: String!, $documentName: String!) {
    seller {
      s3DeleteDocument(bucketName: $bucketName, documentName: $documentName)
    }
  }
`;

export const InitiateMultipartUploadMutation = gql`
  mutation initiateMultipartUpload(
    $bucketName: String!
    $filePath: String!
    $contentType: String!
  ) {
    multipartUploads {
      initiateMultipartUpload(
        input: { bucketName: $bucketName, filePath: $filePath, contentType: $contentType }
      ) {
        uploadToken
      }
    }
  }
`;

export const GenerateMultipartUploadUrlsMutation = gql`
  mutation generateMultipartUploadUrls(
    $uploadToken: String!
    $partIndexStart: Float!
    $partIndexEnd: Float!
  ) {
    multipartUploads {
      generateMultipartUploadUrls(
        input: {
          uploadToken: $uploadToken
          partIndexStart: $partIndexStart
          partIndexEnd: $partIndexEnd
        }
      ) {
        multipartUploadUrls {
          partNumber
          url
        }
      }
    }
  }
`;

export const CompleteMultipartUploadMutation = gql`
  mutation completeMultipartUpload(
    $uploadToken: String!
    $multipartUploadParts: [OdProtosWebServicesMultipartUploads_MultipartUploadPartInput!]
  ) {
    multipartUploads {
      completeMultipartUpload(
        input: { uploadToken: $uploadToken, multipartUploadParts: $multipartUploadParts }
      ) {
        _empty
      }
    }
  }
`;

export const AbortMultipartUploadMutation = gql`
  mutation abortMultipartUpload($uploadToken: String!) {
    multipartUploads {
      abortMultipartUpload(input: { uploadToken: $uploadToken }) {
        _empty
      }
    }
  }
`;
